import { render, staticRenderFns } from "./GestionBodegaInstitucion.vue?vue&type=template&id=adcf4ade&scoped=true"
import script from "./GestionBodegaInstitucion.vue?vue&type=script&lang=js"
export * from "./GestionBodegaInstitucion.vue?vue&type=script&lang=js"
import style0 from "./GestionBodegaInstitucion.vue?vue&type=style&index=0&id=adcf4ade&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adcf4ade",
  null
  
)

export default component.exports